module.exports = __webpack_public_path__ + "img/swiper-ma.5e6340e4.jpg";